(function () {
    'use strict';

    angular
        .module('procedureModule')
        .controller('ProcedureRedirectionController', Controller);

    Controller.$inject = ['$state', 'procedure'];

    function Controller($state, procedure) {
        $state.go('procedure.view', {
            ProcedureType: procedure.MetadataBlock.ProcedureType.Value,
            ProcedureCode: procedure.MetadataBlock.ProcedureCode.Code
        }, {
            location: 'replace'
        });
    }
})();